import type { ContractItemDetailResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodContractItemDetailResponseSchema } from './validations';

/**
 * Fetches a single contract line item by its ID.
 *
 * @param contractId - The UUID of the contract the item belongs to.
 * @param itemId - The UUID of the item to fetch.
 * @param options - Additional request options.
 * @returns The contract item.
 * @throws Error if the API request fails, including 404 for an unknown item.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/get_contract_item_contracts__contract_id__items__item_id__get
 */
export const fetchContractItem = async (
  contractId: UUID,
  itemId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.CONTRACT_ITEM.GET(contractId, itemId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodContractItemDetailResponseSchema,
      },
    })
    .json<ContractItemDetailResponse>();
